import { VSlickCarousel } from 'v-slick-carousel';
import 'v-slick-carousel/style.css';

declare module 'vue' {
  export interface GlobalComponents {
    VSlickCarousel: typeof VSlickCarousel;
  }
}

VSlickCarousel.inheritAttrs = true;

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VSlickCarousel', VSlickCarousel);
});
